import { render } from "./PaymentControlView.vue?vue&type=template&id=53bf3502"
import script from "./PaymentControlView.vue?vue&type=script&lang=js"
export * from "./PaymentControlView.vue?vue&type=script&lang=js"

import exportComponent from "/home/felix/ContinuousLabs/clients/bloqs4/parribaclub/control/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__